module.exports = __webpack_public_path__ + "static/img/bg.a80a759d.jpg";